import React from "react";

export const IconCalloutInfo = ({ className, ...props }) => {
  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22Z"
        fill="url(#paint0_linear_4710_64)"
      />
      <path
        d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#191E49"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id="paint0_linear_4710_64" x1="12" y1="2" x2="12" y2="15" gradientUnits="userSpaceOnUse">
          <stop stopColor="#C098F5" />
          <stop offset="1" stopColor="#C098F5" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
